<template>
  <div>
    <div v-if="dataTabla != null" class="projects-list">
      <div class="project-box" style="cursor: pointer;" v-for="current in dataTabla.results"
        v-bind:key="current.id" @click="rowClick(current)">
        <div class="row project-head" style="border-color: #71c21a;">
          <div class="project-title" style="border-color: #ffffff; text-align: left;">
            <h5 style="font-size: 125%; ;">Recepción #{{ current.numero }}</h5>
            <a>{{ current.proveedor_obj.codigo }} -
              {{ current.proveedor_obj.nombre }}</a>
            <br />
            <a>{{ current.tienda_obj.nombre }}
            </a>
            <p>
              <small>
                <b>
                  {{ formatDatetime(current.fecha_creacion) }} Hrs.
                </b>
              </small>
            </p>
          </div>
          <!-- <div class="project-users">
            <div class="avatar">
              <img alt :src="current.usuario.image" />
            </div>
            <div class="more" v-html="current.usuario.username"></div>
          </div>-->
          <div class="st-meta col-12">
            <div class="badge badge-success-inverted" v-html="current.estado_str"></div>
            &nbsp;
            <div class="status-pill green"></div>
          </div>
        </div>
        <div class="project-info">
          <div class="row align-items-center">
            <div class="col-12">
              <div class="row">
                <div class="col-6">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Facturas</div>
                    <div class="value">{{ current.cantidad_facturas }}</div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Bultos</div>
                    <div class="value">{{ current.cantidad_bultos }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="row-project-footer" style="text-align: right;">
            <b>
              <small style="font-size: 9px;">
                {{ current.usuario_obj.username }}
                -
                <timeago :title="current.fecha_creacion" :datetime="current.fecha_creacion"></timeago>
              </small>
            </b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import RecepcionService from "@/services/wms/RecepcionService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
  },
  props: ["dataTabla"],
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {},
  mounted() { },
  methods: {
    ...mapActions({
      clearInvoiceState: "recepciones/clearInvoiceState",
    }),
    irAEsconderModal(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      this.$router.push({
        name: name,
        params: params,
      });
    },
    rowClick(current) {
      // Ensure any selected/received invoice state in Vuex is cleared
      // before navigating to the edit view so the form loads clean.
      const navigate = () => {
        if (event && event.ctrlKey) {
          let routeUrl = this.$router.resolve({
            name: "wms-recepcion-editar",
            params: {
              id: current.id,
              proveedor: current.proveedor_object,
            },
          });
          window.open(routeUrl.href, "_blank");
        } else {
          this.$router.push({
            name: "wms-recepcion-editar",
            params: {
              id: current.id,
              proveedor: current.proveedor_object,
            },
          });
        }
      };

      // Call the action if available (it should return a promise); always navigate after.
      try {
        const p = this.clearInvoiceState ? this.clearInvoiceState() : Promise.resolve();
        p.then(navigate).catch(navigate);
      } catch (e) {
        // On any error, just navigate to avoid blocking UX
        navigate();
      }
    },
    formatDatetime(date) {
      if (date == null) {
        return "";
      }
      return moment(date).format("DD-MM-YYYY / HH:mm");
    },
  },
};
</script>
